export { default } from "./readAloudButtonsConfig";
